// extracted by mini-css-extract-plugin
export default {"app-market-page":"_1f7wb5u","appMarketPage":"_1f7wb5u","app-box-skeleton":"_ciqyq5","appBoxSkeleton":"_ciqyq5"};